import { render } from "./redirectUrlComponent.vue?vue&type=template&id=176616aa"
import script from "./redirectUrlComponent.vue?vue&type=script&lang=js"
export * from "./redirectUrlComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__